import Style from './maintenance-notice-banner.module.scss';

interface MaintenanceNotice {
  id: string;
  title: string;
  description: string | null;
  startAt: Date;
  probableEndAt: Date | null;
  createdAt?: Date;
  updatedAt?: Date;
}

interface MaintenanceNoticeBannerProps {
  notice: MaintenanceNotice | null;
  onDismiss?: (id: string) => void;
}

function formatDateTime(value: string | number | Date | null | undefined) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

export function MaintenanceNoticeBanner({ notice, onDismiss }: MaintenanceNoticeBannerProps) {
  if (!notice?.id) return null;

  const startAt = formatDateTime(notice.startAt);
  const endAt = formatDateTime(notice.probableEndAt);

  return (
    <div className={Style.banner} role="status" aria-live="polite">
      <div className={Style.message}>
        <strong>{notice.title || 'Scheduled maintenance'}</strong>
        {notice.description ? `: ${notice.description}` : ''}
        {startAt ? ` — Starts ${startAt}` : ''}
        {endAt ? ` (expected to end ${endAt})` : ''}
      </div>

      <button
        type="button"
        className={Style.closeButton}
        onClick={() => onDismiss?.(notice.id)}
        aria-label="Dismiss maintenance notice"
        title="Dismiss"
      >
        ×
      </button>
    </div>
  );
}
